module.exports = __webpack_public_path__ + "img/agromich_logo_white.758284f5.png";